<template>
  <section class="video-carousel">
    <div class="video-carousel-container">
      <div class="video-carousel-title">Videos</div>
      <flickity
        ref="flickity"
        :options="flickityVideoOptions"
        class="video-carousel-flickity"
      >
        <div
          v-for="(item, i) in videoCarouselData"
          :key="item.id"
          class="video-carousel-cell"
          @click="onVideoCarouselItemClick(i)"
        >
          <div class="video-carousel-wrapper">
            <video ref="videos">
              <source
                v-for="src in item.sources"
                :key="src.url"
                :src="src.url"
                :type="src.type"
              >
            </video>
          </div>
          <div class="video-carousel-cell-title">{{ item.name }}</div>
        </div>
      </flickity>
    </div>
  </section>
</template>

<script>
import Flickity from 'vue-flickity';
import PageMixin from '@/shared/pageMixin';

export default {
  name: 'BespokeShow',
  components: {
    Flickity,
  },
  mixins: [PageMixin],
  props: {
    videoCarouselData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
  computed: {
    flickityVideoOptions() {
      return {
        prevNextButtons: this.videoCarouselData.length > 1,
        draggable: true,
        contain: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
      };
    },
  },
  watch: {

  },
  methods: {
    onVideoCarouselItemClick(item) {
      // eslint-disable-next-line no-console
      console.log(this.$refs, item);
    },
  },
};
</script>

<style lang='scss' scoped>
  @import "../../../assets/scss/variables.scss";

  $mm-light-title-color: #F3F1D5;
  $mm-light-text-color: #F7F8DE;
  $mm-dark-color: #89B1AA;
  $mm-dark-background: #2F88A0;
  $mm-light-background-color: #FFFFFA;
  $mm-black-color: #0C132A;
  $mm-almost-black: #121C30;
  $max-width-threshold: 1280px;

  .video-carousel {
    font-family: $inter-medium;
    background: $mm-light-background-color;

    &-container {
      margin: 0 auto;
      max-width: $max-width-threshold;
    }

    &-title {
      font-family: $inter-medium;
      font-weight: bold;
      font-size: 43px;
      line-height: 44px;
      text-align: center;
      letter-spacing: -1px;
    }

    &-flickity /deep/ .flickity-viewport {

    }

    &-flickity /deep/ .flickity-button {
      background: #FFFFFF;
      opacity: 0.9;
      box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);

      &.previous {
        left: -15px !important;
      }

      &.next {
        right: -15px !important;
      }

      svg {
        fill: #00AECB;
      }
    }

    &-wrapper {
      margin: 5px;
    }

    &-cell {
      width: 33.3333%;
      margin: 0;
      padding-bottom: 2.5%;
      opacity: 0.25;
      transition: opacity .3s;

      &.is-selected {
        opacity: 1;
        transition: opacity .3s;
      }

      video {
        width: 100%;
        height: 100%;
      }
    }
  }

</style>
